<template>
	<v-btn
		:class="btnClasses"
		@click="onClick"
		:color="color"
		:text="table || flat"
		:rounded="rounded"
		:disabled="disabled"
		:loading="loading"
		:to="to"
		:href="href"
		:target="target"
		:large="large"
		:small="table || small"
		:tile="tile"
		:outlined="outlined"
		:icon="iconButton"
		:max-height="maxHeight"
	>
		<span v-show="icon" v-if="!iconRight">
			<v-icon>{{icon}}</v-icon>
			<span v-if="!iconOnly">&nbsp;&nbsp;</span>
		</span>
		<slot></slot>
		<span v-show="icon" v-if="iconRight">&nbsp;&nbsp;<v-icon>{{icon}}</v-icon></span>
	</v-btn>
</template>

<script>
export default {
	props: {
		table: Boolean,
		color: String,
		flat: Boolean,
		rounded: Boolean,
		outlined: Boolean,
		disabled: Boolean,
		loading: Boolean,
		to: Object,
		href: [String, Object],
		target: String,
		large: Boolean,
		small: Boolean,
		tile: Boolean,
		icon: String,
		iconOnly: Boolean,
		iconRight: Boolean,
		iconButton: Boolean,
		noMargin: Boolean,
		maxHeight: [Number, String],
	},
	computed: {
		btnClasses() {
			const classes = []
			if (!this.noMargin && !this.table) { classes.push('ma-2') }
			if (this.table) {
				classes.push('table-btn')
				classes.push('ml-1')
			}
			return classes.join(' ')
		},
	},
	methods: {
		onClick(event) {
			this.$emit('click', event)
		},
	},
}
</script>

<style scoped>
	.table-btn {
		font-size: 10px;
	}
</style>
